import React from 'react';
import {useNavigation, useRoute} from '@react-navigation/native';
import {get} from 'lodash';

import Checkbox from '/component/base/Checkbox';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {useTranslation} from '/provider/TranslationProvider';

import testProperties from '../../../../../util/testing/testProperties';
import {generateOnPress} from '../FilterScreen.util';

import {styles} from './FilterItem.style';

import {useRecordsFiltering} from '/context/RecordsFilter/useRecordsFiltering';
interface FilterOption {
  key: string;
  label: string;
}
interface FilterItemProps {
  userId: string;
  item: FilterOption;
  setSelectedFilterParam: (param: FilterOption) => void;
  highestRankDescription: string;
  paidAsRankDescLastMonth: string;
}

export const FilterItem: React.FC<FilterItemProps> = ({
  userId,
  item,
  setSelectedFilterParam,
  highestRankDescription,
  paidAsRankDescLastMonth,
}) => {
  const {tt} = useTranslation('filterScreen.filterItem');
  const navigation = useNavigation();
  const route = useRoute();
  const recordsName = get(route, 'params.recordsName');
  const {filterParam: newFilterParam} = useRecordsFiltering({
    recordsName: recordsName,
  });
  const isSelected = get(item, 'key', '') === get(newFilterParam, 'key', '');
  const filterType = get(item, 'key', '');
  const onPress = generateOnPress({
    filterParam: item,
    setSelectedFilterParam,
    recordsName,
    goBack: navigation.goBack,
    isApplyAction: false,
    highestRankDescription,
    paidAsRankDescLastMonth,
    filterType,
    userId,
  });

  return (
    <TouchableOpacity
      style={styles.itemContainer}
      onPress={onPress}
      {...testProperties(null, true)}
      accessible={true}
      accessibilityRole="radio"
      accessibilityState={{selected: isSelected}}
      accessibilityLabel={item.label}>
      <Checkbox
        checked={isSelected}
        checkedIconName="radio"
        style={{icon: styles.icon}}
        readonly
      />
      <Text testID={get(item, 'key', '')}>
        {tt(
          `filterOptionLabel-${get(item, 'key', '')}`,
          get(item, 'label', ''),
        )}
      </Text>
    </TouchableOpacity>
  );
};
